import { SHOW_AMAZON_PRICE } from "../config/amazonDataAvailability.js";

/**
 * Price line for reco cards. Gated behind `SHOW_AMAZON_PRICE` — we're scraping prices
 * off Amazon product pages today, they go stale immediately, and we can't refresh them
 * without the Amazon Product Advertising API, so we hide the price for now rather than
 * risk showing a wrong one. Keeps taking `priceText` + `className` so call sites and the
 * `.frontRecoPrice` / `.compactPrice` styles stay unchanged; flip the flag to bring it back.
 */
export default function RecoPrice({ priceText, className }) {
  if (!SHOW_AMAZON_PRICE || !priceText) return null;
  return <p className={className}>{priceText}</p>;
}
